<!--  -->
<template>
  <el-dialog
    title="选择委托机构"
    :visible.sync="bidOrgVisible"
    width="600px"
    :before-close="cancelHandle"
    :append-to-body="true"
    class="createBatchProducts-dialog"
  >
    <!-- <el-form :inline="true" :model="categoryQuery" ref="categorySearchQuery" class="search-form">
      <el-form-item label="末级分类名称：">
        <el-input v-model="categoryQuery.categoryName" placeholder="请输入末级分类名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="categorySearch">查询</el-button>
        <el-button @click="categoryReset">重置</el-button>
      </el-form-item>
    </el-form> -->
    <el-table :data="tableData" border max-height="280" :show-header="false">
      <el-table-column prop="name" label="招标机构" min-width="160">
        <template slot-scope="scope">
          <el-radio
            :label="scope.row.name"
            v-model="currentName"
            @change.native="getCurrent(scope.row)"
          ></el-radio>
        </template>
      </el-table-column>
    </el-table>
    <!-- <div class="pagination-box">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, prev, pager, next, jumper"
        :current-page="listQuery.pageNum"
        :total="total"
        :page-size.sync="listQuery.pageSize"
      ></el-pagination>
    </div> -->
    <div slot="footer" class="dialog-footer">
      <div class="btn default-btn" @click="cancelHandle">取 消</div>
      <div @click="handleSure" class="btn submit-btn">确定</div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    bidOrgVisible: Boolean,
  },
  data() {
    return {
      tableData: [],
      listQuery: {
        pageNum: 1,
        pageSize: 10,
      },
      cloneListQuery: {},
      total: 0,
      paramRow: {},
      currentName: '',
      tableData: [
        {
          name: '中技国际招标机构',
          id: '1002',
        },
        {
          name: '中招国际招标机构',
          id: '1003',
        },
        {
          name: '中钢招标机构',
          id: '1004',
        },
      ],
    };
  },
  methods: {
    handleSure() {
      this.$router.push({
        path: '/activity/bidinfo',
      });
    },
    cancelHandle() {
      this.$emit('update:bidOrgVisible', false);
    },
    getCurrent(row) {
      this.paramRow = { ...row };
    },
    // 跳转链接
    goToUrl(url) {
      this.$router.push({ path: url });
    },
    async getHistoryList(params) {
      try {
        await api.selectSkuImportFilePage(params).then(res => {
          if (res.code === '200') {
            const data = res.data;
            this.tableHistoryData = [...data.records];
            this.total = data.total;
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.getHistoryList(this.listQuery);
    },
    handleSizeChange(val) {
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = val;
      this.getHistoryList(this.listQuery);
    },
  },
};
</script>
<style lang="scss" scoped>
.createBatchProducts-dialog {
  // 列表重置样式-开始
  ::v-deep .el-table__header .cell {
    .icon-question {
      height: 18px;
      width: 18px;
      line-height: 18px;
      text-align: center;
      border-radius: 50%;
      border: 1px solid #c5c5c5;
      color: #c5c5c5;
      display: inline-block;
      margin-left: 10px;
      &:hover {
        color: #fff;
        background-color: #c5c5c5;
      }
    }
  }
  ::v-deep .el-table__row .cell {
    font-size: 12px;
    white-space: normal;
    padding-left: 6px;
    padding-right: 6px;
    .el-button {
      font-size: 12px;
    }
    .el-input__inner {
      padding: 0 6px;
    }
    .edit-info {
      color: #c0c4cc;
    }
  }
  ::v-deep .el-table--small td,
  ::v-deep .el-table--small th {
    padding: 6px 0;
  }
  ::v-deep .el-table--small .el-table-column--selection {
    .cell {
      padding-left: 10px;
      padding-right: 10px;
      .el-checkbox__inner {
        border-radius: 0;
      }
    }
  }
  // 列表重置样式-结束

  // dialog 重置样式开始
  ::v-deep .el-dialog__body {
    padding: 10px 10px 0 10px;
  }
  ::v-deep.el-dialog__header {
    background: #f5f5f5;
    height: 40px;
    padding: 0 20px;
    line-height: 40px;
    .el-dialog__headerbtn {
      top: 8px;
    }
    .el-dialog__title {
      font-size: 14px;
    }
  }
  .el-dialog__footer div {
    display: flex;
    justify-content: center;
    .btn {
      width: 80px;
      text-align: center;
      height: 30px;
      line-height: 27px;
      cursor: pointer;
      padding: 0;
      border-radius: 0;
      margin-right: 10px;
    }
    .reset-btn {
      background: #e8efff;
      border: 1px solid #2587ff;
      color: #2587ff;
      margin-left: 20px;
      line-height: 27px;
      &:hover,
      :active {
        background-color: #126edf;
        color: #fff;
      }
    }
    .submit-btn {
      background: #2587ff;
      border: 1px solid #2587ff;
      color: #ffffff;
      &:hover,
      :active {
        background-color: #126edf;
      }
    }
    .default-btn {
      background: #fff;
      border: 1px solid #dcdfe6;
      &:hover {
        border-color: #2587ff;
        color: #2587ff;
      }
    }
  }
  .pagination-box {
    text-align: right;
    margin-top: 10px;
    ::v-deep .el-pagination {
      button {
        height: 30px;
        color: #999;
      }

      .el-select {
        .el-input__inner {
          border-radius: 0;
          height: 30px;
        }
      }

      .el-input__inner {
        border-radius: 0;
        height: 30px;
        color: #999;
      }

      .el-select-dropdown__item,
      .el-pagination__jump,
      .el-pagination__total {
        color: #999;
        line-height: 30px;
      }

      .el-pager {
        li {
          border-radius: 0;
          border: 1px solid #d9d9d9;
          line-height: 28px;
          text-align: center;
          margin-left: 10px;
          width: 40px;
          height: 30px;
          color: #999;

          &:first-child {
            margin-left: 0;
          }

          &.active {
            background: #2587ff;
            border: none;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
